module.exports = __webpack_public_path__ + "img/share.a2e7cde0.svg";